module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921052651_T.33f9b390.jpg";